const LoadingAll = ({
	width = "50px",
	height = "100vh",
	dotSize = "12px",
	gap = "8px",
	color = "#d1d5db", // gray-300
	duration = 1,
	className = "",
}) => {
	return (
		<div
			className={`flex items-center justify-center ${className}`}
			style={{ height }}
		>
			<div
				className="flex items-center justify-between"
				style={{
					width,
					gap,
				}}
			>
				{[0, 0.1, 0.2].map((delay, index) => (
					<span
						key={index}
						className="rounded-full animate-pulse"
						style={{
							width: dotSize,
							height: dotSize,
							backgroundColor: color,
							animationDuration: `${duration + delay}s`,
						}}
					/>
				))}
			</div>
		</div>
	);
};

export default LoadingAll;